<template>
  <div>
    <div v-if="!loading">
      <div class="uk-container">
        <div class="uk-flex uk-flex-center">
          <div class="uk-width-1-2@m uk-width-1-1 uk-margin-top">
            <div class="uk-margin-bottom uk-width-1-1">
              <div class="uk-flex uk-flex-right">
                <div class="no_deperindag uk-margin-bottom" v-if="data.no_deperindag != false">
                  NO. DEPERINDAG: <br />
                  {{ data.no_deperindag }}
                </div>
              </div>
              <table id="custom-table-check">
                <tr>
                  <td
                    style="
                      vertical-align: middle;
                      text-align: center;
                      padding: 30px 0px;
                    "
                  >
                    <img
                      src="../../assets/images/roomi-egaransi.png"
                      style="width: 100px"
                    />
                  </td>
                  <td
                    style="
                      vertical-align: middle;
                      text-align: center;
                      font-size: 25px;
                      font-weight: bold;
                    "
                  >
                    E-Garansi Roomi
                  </td>
                </tr>
                <tr>
                  <th>Jenis Barang</th>
                  <td>{{ data.product_type }}</td>
                </tr>
                <tr>
                  <th>Model</th>
                  <td>{{ data.product_model }}</td>
                </tr>
                <tr>
                  <th>No. Seri</th>
                  <td>{{ data.product_code }}</td>
                </tr>
                <tr>
                  <th>Periode Garansi</th>
                  <td>
                    {{ shortlessDate(data.start_date) }} -
                    {{ shortlessDate(data.end_date) }}
                  </td>
                </tr>
                <tr>
                  <th>Nama Pemilik</th>
                  <td>{{ data.customer_name }}</td>
                </tr>
                <tr>
                  <th>No Handphone</th>
                  <td>{{ data.customer_phone }}</td>
                </tr>
                <tr>
                  <th>Alamat</th>
                  <td>{{ data.customer_address }}</td>
                </tr>
                <tr>
                  <th>Nama Toko</th>
                  <td>{{ data.store_name }}</td>
                </tr>
                <tr>
                  <th>Alamat Toko</th>
                  <td>{{ data.store_address }}</td>
                </tr>
              </table>
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <hr style="border-top: 1px solid #bbbbbb" />
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <span class="service-center-title">SERVICE CENTER</span>
            </div>
            <div class="uk-width-1-1 uk-margin-bottom">
              <table class="uk-table custom-table">
                <tbody>
                  <tr>
                    <th>Jakarta</th>
                    <td>
                      Jl. Mangga Dua Raya, Komp. Agung Sedayu Blok L No. 25-26 Mangga Dua Selatan, Sawah Besar, Jakarta Pusat 10730 , Telp. (021) 6286289
                    </td>
                  </tr>
                  <tr>
                    <th>Bandung</th>
                    <td>
                      Jl. Raya Cibeureum No.111/115 Cibereum, Cimahi Selatan, Kota Cimahi 40535 , Telp. (022) 20583460 / 081380728336
                    </td>
                  </tr>
                  <tr>
                    <th>Surabaya</th>
                    <td>
                      Pergudangan Mutiara Tambak Langon D-30 Asem Rowo, Surabaya 60184 , Telp. (031) 7496759
                    </td>
                  </tr>
                  <tr>
                    <th>Purwokerto</th>
                    <td>
                      Jl. Jenderal Sudirman, Komplek Ruko Eks Kodim No.21, 53114 Purwokerto Timur , Telp. (0281) 631727
                    </td>
                  </tr>
                  <tr>
                    <th>Medan</th>
                    <td>
                      Jl. Krakatau Ujung Komplek Krakatau Multi Center (KMC) Blok C3 Medan Timur, Medan 20236 , Telp. 082164112675
                    </td>
                  </tr>
                  <tr>
                    <th>Pekanbaru</th>
                    <td>
                      Jl. Siak Dua No. 887-888 Palas, Rumbai, Pekanbaru 28264 , Telp. 085225566900
                    </td>
                  </tr>
                  <tr>
                    <th>Jambi</th>
                    <td>
                      Jl. Amangkurat No.88A RT 26 Tj. Pinang, Jambi Timur, Jambi 36146 , Telp. (0741) 27456
                    </td>
                  </tr>
                  <tr>
                    <th>Palembang</th>
                    <td>
                      Jl. Residence Abdul Rozak No.12 (Pergudangan No. 1 Mandala Jaya Pro Shop Dunlop) Kalidoni, Palembang 30163 , Telp. 082177479574
                    </td>
                  </tr>
                  <tr>
                    <th>Lampung</th>
                    <td>
                      Jl. Yos Sudarso No.10 Way Lunik, Bandar Lampung 35221 , Telp. 085369266613
                    </td>
                  </tr>
                  <tr>
                    <th>Pontianak</th>
                    <td>
                      Jl. Arteri Supadio Komplek Pergudangan Extra Joss Blok C5 Kubu Raya, Pontianak 78384 , Telp. (0561) 6711361 / 081345064987
                    </td>
                  </tr>
                  <tr>
                    <th>Makassar</th>
                    <td>
                      Pergudangan KIMA SQUARE WAREHOUSE 1 Jl. Kima Raya 2 No.30-31 Daya, Biringkanaya, Makassar 90242 , Telp. (0411) 4723314 / 081342399950
                    </td>
                  </tr>
                  <tr>
                    <th>Manado</th>
                    <td>
                      Volvo Penta B II Jl. Arnold Mononutu Watutumou, Kalawat, Minahasa Utara 95378 , Telp. 081355503076
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <hr style="border-top: 1px solid #bbbbbb" />
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <span class="service-center-title">HUBUNGI KAMI</span>
            </div>
            <div class="uk-width-1-1 uk-margin-bottom">
              <table class="uk-table custom-table">
                <tbody>
                  <tr>
                    <th>Whatsapp</th>
                    <td>
                      <a href="https://wa.me/6281113901291" target="_blank"
                        >081113901291</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>
                      <a href="mailto:cs@roomi.co.id">cs@roomi.co.id</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <hr style="border-top: 1px solid #bbbbbb" />
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <span class="service-center-title">CUSTOMER SERVICE</span>
            </div>
            <div class="uk-width-1-1 uk-margin-bottom">
              <table class="uk-table custom-table">
                <tbody>
                  <tr>
                    <th>Whatsapp</th>
                    <td>
                      <a
                        href="https://wa.me/628119965111"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://wa.me/628119965111</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>Livechat</th>
                    <td>
                      <a
                        href="https://tinyurl.com/y8zfv8uz"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://tinyurl.com/y8zfv8uz</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <hr style="border-top: 1px solid #bbbbbb" />
            </div>
            <div class="uk-margin-bottom uk-width-1-1">
              <h5 class="uk-text-bold uk-text-center">
                Terimakasih atas pembelian produk bermutu ROOMI<br />Semoga Anda
                puas setelah menggunakan produk ROOMI
              </h5>
              <p>Ketentuan-ketentuan garansi :</p>
              <ul class="uk-list uk-list-decimal uk-list-primary">
                <li>
                  Garansi berlaku selama 1 tahun, terhitung dari tanggal
                  pembelian, termasuk spare parts.
                </li>
                <li>Biaya transportasi/pengiriman ditanggung oleh pemilik.</li>
                <li>
                  Apabila kartu garansi telah habis, biaya service dan spare
                  parts ditanggung oleh pemilik sesuai dengan kerusakan barang.
                </li>
              </ul>
              <p>Garansi tidak berlaku apabila :</p>
              <ul class="uk-list uk-list-decimal uk-list-primary">
                <li>Telah direparasi / diperbaiki oleh pihak lain.</li>
                <li>Kartu garansi hilang dan nomor seri tidak sesuai.</li>
                <li>
                  Kartu garansi tidak didaftarkan dalam waktu 10 (sepuluh) hari
                  setelah tanggal pembelian.
                </li>
                <li>
                  Force Majeure (Kejadian-kejadian diluar kuasa) Bencana alam,
                  Perang, Sabotase, Kerusuhan, Pemogokan umum, Huru Hara,
                  Kebakaran, Terkena sambaran petir, Tegangan listrik yang
                  terlalu tinggi atau tidak stabil, Peraturan pemerintah baik
                  Pusat/Daerah/Instansi/POLRI dan hal-hal lainnya yang oleh
                  Pejabat resmi dinyatakan sebagai FORCE MAJEURE.
                </li>
                <li>
                  Kerusakan yang disebabkan oleh kelalaian pemakai, misalnya :
                  jatuh, terkena air/api, maupun bahan kimia.
                </li>
                <li>Kesalahan pemasangan.</li>
                <li>
                  Kerusakan yang disebabkan oleh jamur, binatang/serangga.
                  seperti : cicak, kecoa, rayap, tikus.
                </li>
                <li>
                  Pernah direparasi sendiri oleh pihak lain (Selain teknisi
                  resmi ROOMI).
                </li>
                <li>
                  Tidak menunjukan kartu garansi pada saat melakukan reparasi.
                </li>
                <li>Tidak mengisi kartu garansi dengan lengkap.</li>
                <li>
                  Masa berlaku kartu garansi ini telah habis sesuai dengan yang
                  tertera.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div class="uk-flex uk-flex-center uk-flex-middle" style="height: 100%">
          <div uk-spinner></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { shortlessDate } from "@/utils/utils.js";

export default {
  data() {
    return {
      data: {},
      loading: false,
    };
  },
  mounted() {
    if (this.defaultSN == "") {
      this.$router.push("/not-found");
    }
    this.checkGuarantee();
    var whatsappButton = document.getElementsByClassName("whatsapp-button")[0];
    whatsappButton.setAttribute("style", "display:none;");
  },
  computed: {
    defaultSN() {
      return this.$route.query.sn != undefined ? this.$route.query.sn : "";
    },
  },
  methods: {
    checkGuarantee() {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}guarantee/check/${this.defaultSN}`
        )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            const data = res.data;
            if (data.success) {
              this.data = data.data;
            } else {
              this.$router.push("/not-found");
            }
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$router.push("/not-found");
        });
    },
    shortlessDate(date) {
      return shortlessDate(date);
    },
  },
};
</script>

<style scoped>
.no_deperindag {
  border: 3px solid #dddddd;
  padding: 10px;
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
}
@page {
  size: A4 portrait;
}
ul.app-desc {
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  line-height: 1;
  width: 50%;
}

ul.app-desc li {
  padding: 2.5px 0;
  text-transform: capitalize;
  color: rgb(164, 173, 184);
  word-spacing: 2px;
  font-weight: 300;
  letter-spacing: 1.5px;
}

ul.app-desc li::after {
  content: "|";
  margin-left: 5px;
  margin-right: 5px;
}

ul.app-desc li:last-child::after {
  content: "";
}

/* ul.uk-slider-items li img {
	height: 200px;
} */

.card-download {
  cursor: pointer;
}

.card-download:hover {
  box-shadow: 0 5px 15px rgb(0 0 0 / 25%) !important;
}

@media screen and (max-width: 639px) {
  .text-container > * {
    text-align: center;
  }

  ul.app-desc {
    margin: auto;
    display: inline-block;
    width: 100%;
  }

  ul.app-desc li a {
    text-align: center;
  }

  ul.app-desc li::after {
    content: "";
  }
}

.whatsapp-button,
.whatsapp-button-mobile {
  display: none;
}

#custom-table-check {
  border-spacing: 0;
  width: 100%;
}
#custom-table-check th {
  margin: 0;
  border: 1px solid #ddd;
  text-align: left;
  padding: 8px;
}
#custom-table-check td {
  margin: 0;
  border: 1px solid #ddd;
  text-align: left;
  padding: 8px;
}

.custom-table th {
  color: black;
  font-weight: bold;
  vertical-align: top;
  padding: 8px;
}

.custom-table td {
  padding: 8px;
}

.custom-table tr {
  border-top: 1px solid rgb(187, 187, 187);
}

.service-center-title {
  background: #3455a6;
  font-size: 20px;
  color: white;
  width: 100%;
  text-align: center;
  padding: 4px;
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
}

@media print {
  .service-center-title {
    background: #3455a6 !important;
    color: white !important;
    -webkit-print-color-adjust: exact;
  }
  body {
    -webkit-print-color-adjust: exact;
  }
}
</style>